export var DesktopVariants;
(function (DesktopVariants) {
    DesktopVariants["HIDDEN"] = "hidden";
    DesktopVariants["FULLSCREEN"] = "fullscreen";
    DesktopVariants["POPUP"] = "popup";
    DesktopVariants["OVERLAY_FORM"] = "overlayForm";
    DesktopVariants["OVERLAY_FORM_LARGE"] = "overlayFormLarge";
})(DesktopVariants || (DesktopVariants = {}));
